import React, { useCallback, useState } from 'react';
import Depot from '../_shared/depot';
import TabNavLink from './TabNavLink';
import useActiveTabAnimation from './hooks/useActiveTabAnimation';
import TabContent from './TabContent';
import TabListWrapper from './TabListWrapper';
const TabsWithoutRef = ({ onTabChange, className, items, defaultActiveTabKey, allowHorizontalScroll = false, ...commonProps }) => {
    var _a;
    const [activeTabKey, setActiveTabKey] = useState((_a = defaultActiveTabKey !== null && defaultActiveTabKey !== void 0 ? defaultActiveTabKey : items[0].key) !== null && _a !== void 0 ? _a : '0');
    const { tabRef, linePosition } = useActiveTabAnimation(activeTabKey);
    const handleTabChange = useCallback((key, event) => {
        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(key, event);
        setActiveTabKey(key);
    }, [onTabChange]);
    return (React.createElement(React.Fragment, null,
        React.createElement(TabListWrapper, { ...commonProps, allowHorizontalScroll: allowHorizontalScroll, className: className }, items.map(({ key, label, icon }) => {
            return (React.createElement(TabNavLink, { label: label, key: key, tabKey: key, active: key === activeTabKey, onTabClick: handleTabChange, icon: icon, scrollable: allowHorizontalScroll, activePosition: linePosition, ref: tabRef }));
        })),
        items.map(({ key, content }) => (React.createElement(TabContent, { key: key, tabKey: key, content: content, active: key === activeTabKey })))));
};
const Tabs = Depot.withRef(TabsWithoutRef);
Tabs.displayName = 'Tabs';
export default Tabs;
//# sourceMappingURL=index.js.map